import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    frameId: String
  }

  connect() {
    console.log("Plan select controller connected")
  }
  
  change(event) {
    const planId = event.target.value
    
    if (planId) {
      const frame = document.getElementById(this.frameIdValue)
      
      if (frame) {
        // Construct the URL for the admin prices path
        const baseUrl = window.location.pathname.split('/').slice(0, 3).join('/')
        const url = `${baseUrl}/${planId}/prices`
        
        // Navigate the frame to the new URL
        frame.src = url
        // Needed for frame navigation
        frame.reload()
      }
    }
  }
}